import { v4 as uuidv4 } from 'uuid';

import { categoriesSelectors } from 'app-components/flux/categories';
import store from 'app-components/utils/redux-store';

const recurringTransactions = (account) => {
  const postedOn = '2025-04-15';
  const federalEstimatedTaxPaymentCategory = categoriesSelectors.getFederalEstimatedTaxPaymentCategory(
    store.getState(),
  );
  const baseTransaction = {
    source: 'QCS_REFRESH',
    accountId: account?.id,
    postedOn,
    payee: 'United States Treasury',
    coa: {
      type: 'CATEGORY',
      id: federalEstimatedTaxPaymentCategory.id,
    },
    amount: -100,
    state: 'CLEARED',
    matchState: 'NOT_MATCHED',
    cpData: {
      id: uuidv4(),
      cpPendingId: uuidv4(),
      postedOn,
      txnOn: postedOn,
      amount: -100,
      payee: 'United States Treasury',
      inferredPayee: 'United States Treasury',
      inferredCoa: {
        type: 'UNCATEGORIZED',
        id: '0',
      },
      cpCategoryId: '2002',
    },
    type: 'CASH_FLOW',
  };
  return [
    {
      ...baseTransaction,
      postedOn: '2025-04-15',
      amount: -1000,
      cpData: {
        ...baseTransaction.cpData,
        id: uuidv4(),
        cpPendingId: uuidv4(),
        postedOn: '2025-04-15',
        amount: -1000,
      },
    },
    {
      ...baseTransaction,
      postedOn: '2025-06-15',
      amount: -2000,
      cpData: {
        ...baseTransaction.cpData,
        id: uuidv4(),
        cpPendingId: uuidv4(),
        postedOn: '2025-06-15',
        amount: -2000,
      },
    },
  ];
};

export default recurringTransactions;
